export default "__VITE_ASSET__lS09LGJ4__"